import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'

// NOTE
// <Link>'s won't work inside of modals due to how we're using
// React portals (react-router-dom is undefined inside of the
// portal elements.
//
// Instead, use <a>'s :)

// Modals
// - Onboarding
import OnboardingSuccessModal from './Onboarding/OnboardingSuccessModal'
import OnboardingSuccessTrialModal from './Onboarding/OnboardingSuccessTrialModal'
import StripePaymentConfirmationModal from './Payment/StripePaymentConfirmationModal'
// - Global
import SharingButtonsModal from './Sharing/SharingButtonsModal'
// - Marketing
import MarketingLearnMoreModal from './Marketing/MarketingLearnMoreModal'
import MarketingHowItWorksModal from './Marketing/MarketingHowItWorksModal'

// Variables
const modalRoot = document.getElementById('root')

class ModalConductor extends Component {

  constructor(props) {
    super(props)
    this.el = document.createElement('div')
    this.el.className="modal-conductor"
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the ModalConductor's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    modalRoot.appendChild(this.el)
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el)
  }

  renderModal() {
    let { modalType, optionalProps } = this.props.modal

    switch (modalType) {
      case 'onboarding-success':
        return <OnboardingSuccessModal />
      case 'onboarding-success-trial':
        return <OnboardingSuccessTrialModal />
      case 'stripe-payment-confirmation':
        return <StripePaymentConfirmationModal
          stripeToken={optionalProps.token}
          taxRate={optionalProps.taxRate}
          address={optionalProps.address}
          coupon={optionalProps.coupon}
          athleteUsername={optionalProps.athleteUsername}
          numberOfSports={optionalProps.numberOfSports}
          modalLocation={optionalProps.modalLocation}
        />
      case 'share-this':
        return <SharingButtonsModal
          shareUrl={optionalProps.shareUrl}
          shareHeadingText={optionalProps.shareHeadingText}
          shareText={optionalProps.shareText}
          helperText={optionalProps.helperText}
        />
      case 'learn-more':
        return <MarketingLearnMoreModal
          surheading={optionalProps.surheading}
          heading={optionalProps.heading}
          content={optionalProps.content}
          videoId={optionalProps.videoId}
          nextLinkModal={optionalProps.nextLinkModal}
          nextLinkText={optionalProps.nextLinkText}
        />
      case 'how-it-works':
        return <MarketingHowItWorksModal
          heading={optionalProps.heading}
          description={optionalProps.description}
          videoId={optionalProps.videoId}
        />
      default:
        return null
    }
  }

  render() {
    return ReactDOM.createPortal(
      this.renderModal(),
      this.el,
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
  }
}

export default connect(
  mapStateToProps,
  null
)(ModalConductor)



// WEBPACK FOOTER //
// ./src/components/Modals/ModalConductor.js